import React from 'react';
import { CloudUploadOutlined } from '@ant-design/icons';
import editButton from '../../../assets/images/new-dashboard/edit.svg';
import { EditOrganisationSignaturesProps } from './types/EditOrganisationTypes';



const EditOrganisationSignatures = (props: EditOrganisationSignaturesProps) => {
  const {
    selectedhrImage, handlehrImage,
    selectedCeoImage, handleCeoImage,
    selectedCtoImage, handleCtoImage,
    selectedCooImage, handleCooImage,
    selectedItImage, handleItImage,
    selectedFinanceImage, handleFinanceImage
  } = props;

  const signatures = [
    { title: 'Upload CEO Signature', image: selectedCeoImage, handler: handleCeoImage },
    { title: 'Upload COO Signature', image: selectedCooImage, handler: handleCooImage },
    { title: 'Upload CTO Signature', image: selectedCtoImage, handler: handleCtoImage },
    { title: 'Upload HR Signature', image: selectedhrImage, handler: handlehrImage },
    { title: 'Upload IT Signature', image: selectedItImage, handler: handleItImage },
    { title: 'Upload Finance Signature', image: selectedFinanceImage, handler: handleFinanceImage },
  ];


  return (
    <div className='grid grid-cols-3 gap-12 '>
      {signatures.map((sig, index) => (
        <div className='organisation_sign' key={index}>
          <div className='flex flex-col items-start'>
            <h4 className='m-0 mb-1'>{sig.title}</h4>
            <div className='sign-file-upload relative !m-0'>
              <div className='sign-file-upload-inner relative flex items-center justify-center'>
                <input type='file' accept='image/*' className='absolute' onChange={sig.handler} />
                {sig.image && <img src={sig.image} alt='Signature' className='sign-uploaded' />}
                {!sig.image && (
                  <span className='material-symbols-outlined cloud' style={{ paddingLeft: 0 }}>
                    <CloudUploadOutlined />
                  </span>
                )}
                <span className='material-symbols-outlined edit flex items-center absolute right-0'>
                  <img src={editButton} alt='Edit' className='cursor-pointer' />
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EditOrganisationSignatures;
